<template>
    <Bulletins :Mode="true" :Type="AppServiceID"></Bulletins>
</template>

<script>
import Vue from 'vue';
import Bulletins from '@/components/DPEBB/Administrator/Bulletins.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function(){
        return {
        AppServiceID : '',
        }
    },
    components: {

        Bulletins,

    },
created: function() {
    this.AppServiceID = this.$store.getters.GetDPEBBServiceID;
    this.$emit('update:layout', LayoutDefault);
},   
 beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>

<style>

</style>
